// browser polyfills
import 'core-js/stable';
import 'whatwg-fetch';

import React, { useState, Suspense } from 'react';
import { Layout, Result } from 'antd';
import NackleMenu from '@nackle/menu';
const { Content, Sider } = Layout;

import { Route, Link, routeHistory } from '@nackle/biw-web-router';
import { routes, bundleRoutingMiddleware } from './app-routing';

import { Bridge } from '@nackle/bridge';
import auth from './app-auth';
import {
    AppHeader,
    AppFooter,
    AppError,
    CMXService,
    applyRequestMiddleware,
    authRequestMiddleware,
    authRouteMiddleware
} from '@nackle/studio-tools';

import { setLanguageBundle } from '@nackle/intl-tools';

import '@nackle/studio-tools/dist/studio-tools.css';
import './styles/app.less';
import './styles.less';

export default function App() {
    const [ loaded, setLoaded ] = useState( false );
    const [ cmxBundleLoaded, setCMXBundleLoaded ] = useState( false );
    const [ accessToken, setAccessToken ] = useState( '' );

    const handleSignIn = async () => {
        await routeHistory.refresh();

        const locale = auth.state.claims.locale;

        const cmxService = new CMXService( auth.state );
        const bundle = await cmxService.getBundle( [ 'navigation', 'studio-in-context-help' ], locale );
        setLanguageBundle( locale, bundle );

        setLoaded( true );
        setCMXBundleLoaded( true );
        setAccessToken( auth.state.access_token );

    };

    const handleCompanyChange = ( company ) => {
        routeHistory.push( `/${ company.id }` );
    };

    return (
        <AppError>
            <Route render={ ( route ) => {
                // set the title
                document.title = route && route.match ? route.match.title : 'Home';

                const companyId = route.state?.params?.companyId;

                return (
                    <Bridge
                        auth={ auth }
                        onSignIn={ handleSignIn }
                    >
                        { loaded &&
                            <Layout className="root-layout">
                                <AppHeader
                                    auth={ auth }
                                    companyId={ companyId }
                                    onCompanyChange={ handleCompanyChange }
                                />
                                <Layout>
                                    <Sider>
                                        <NackleMenu
                                            auth={ auth }
                                            cmxBundleLoaded={ cmxBundleLoaded }
                                        />
                                    </Sider>
                                    <Layout className="page-layout">
                                        <Suspense fallback={ <div>Loading...</div> }>
                                            <Content className="app-content">
                                                {
                                                    route.match ?
                                                        // react.cloneElement expects an element, props, and any optional args
                                                        React.cloneElement( route.component, { companyId, accessToken } )
                                                        : (
                                                            <Result
                                                                status="404"
                                                                title="404"
                                                                subTitle="Sorry, the page you visited does not exist."
                                                                extra={ <Link to="/" className="ant-btn ant-btn-primary">Back Home</Link> }
                                                            />
                                                        )
                                                }
                                            </Content>
                                            <AppFooter />
                                        </Suspense>
                                    </Layout>
                                </Layout>
                            </Layout>
                        }

                    </Bridge>
                );
            } } />
        </AppError>
    );
}

// connect routing
routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( [ authRouteMiddleware( auth ), bundleRoutingMiddleware ] );

// connect Auth to Fetch
applyRequestMiddleware( authRequestMiddleware( auth ) );
